const blacklist = [
  "asshole",
  "avorton",
  "balai à chiottes",
  "bander",
  "bastard",
  "batard",
  "biatch",
  "biffle",
  "biffler",
  "bifle",
  "bifle",
  "biloute",
  "bamboula",
  "bitch",
  "biatch",
  "bite",
  "bouffon",
  "bollocks",
  "boukake",
  "bougnoul",
  "bougnoule",
  "bounioul",
  "bounioule",
  "branler",
  "branleur",
  "bullshit",
  "burne",
  "chagasse",
  "chier",
  "chiennasse",
  "chinnetoque",
  "connard",
  "connarde",
  "connasse",
  "couille",
  "casse-couille",
  "couille molle",
  "cocksucker",
  "crétin",
  "cul",
  "cul terreux",
  "cunt",
  "damn you",
  "débile",
  "dick",
  "dickhead",
  "dumbass",
  "ducon",
  "emmerder",
  "emmerdeur",
  "emmerder",
  "enculer",
  "enfoiré",
  "enflure",
  "face de",
  "fdp",
  "fils de pute",
  "fiend",
  "foutre",
  "fuck",
  "fuck off",
  "fuck you",
  "fumier",
  "fumier",
  "garce",
  "garage à bite",
  "gland",
  "guignol",
  "gueule",
  "gueulard",
  "gogole",
  "gougnafier",
  "grognasse",
  "idiot",
  "jerk",
  "lèche cul",
  "lopette",
  "merde",
  "merdeux",
  "motherfucker",
  "nazi",
  "negger",
  "négro",
  "niaqué",
  "niaquoué",
  "niquer",
  "nique ta mère",
  "ntm",
  "pd",
  "pédé",
  "pédale",
  "piece of sheet",
  "pain in the ass",
  "putain",
  "pute",
  "race",
  "raclure",
  "salaud",
  "salopard",
  "salope",
  "smartass",
  "smart-ass",
  "sagouin",
  "shit",
  "shut up",
  "suck my dick",
  "son of a bitch",
  "tapette",
  "tas de merde",
  "trainée",
  "trouduc",
  "triso",
  "trisomique",
  "truie",
  "wanker",
  "whore",
  "youpin",
  "youpine",
  "juif",
  "armani",
  "balmain",
  "burberry",
  "cacharel",
  "cartier",
  "chanel",
  "chaumet",
  "dior",
  "dolce gabana",
  "fendi",
  "givenchy",
  "gucci",
  "kenzo",
  "lancel",
  "lancôme",
  "louboutin",
  "louis vuitton",
  "lanvin",
  "lacome",
  "miu miu",
  "jimmy shoo",
  "jp gaultier",
  "givenchy",
  "gerlain",
  "hermes",
  "prada",
  "ralph lauren",
  "rolex",
  "valentino",
  "versace",
  "ysl"
]